import React, { useEffect, useState } from "react";
import { Button, Card, Divider, Space, Table, Typography, } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getApiData, } from "../../store/urlfilter";
import PreloaderNew from "../UI/PreloaderNew/PreloaderNew";
import styles from "./UrlFilterNew.module.css"
import { IconDownloadFile } from "../../icons";
import { getCheckErrors, getDocumentData, getLoaders } from "../../store/documentation/selectors";
import { getDocFile, getDocumentsList, } from "../../store/documentation";
const { Title, Text } = Typography;
const styleTextGray = { color: "#7A7D86" };

function Documentation() {

	const dispatch = useDispatch()
	const errors = useSelector(getCheckErrors)
	const isLoader = useSelector(getLoaders);
	const docData = useSelector(getDocumentData)

	useEffect(() => {
		dispatch(getDocumentsList({ service: 'url_f' }))
	}, []);


	const downloadFile = async (file) => {
		let stringType=  file.doc_file.slice(-5);
		let index = stringType.lastIndexOf('.') ;
		dispatch(getDocFile({ url: file.doc_file, name: file.name, typeFile: stringType.slice(index + 1)}))
	}
	const columns = [

		createColumn("Название", "name"),
		createColumn("Описание", "description"),
		createColumn("Изменено", "date_modified"),
		createColumn("Скачать", "doc_file", (text, row) =>
			<Button size="small" type="text" icon={<IconDownloadFile style={{ color: "#8090B8" }} />}
				onClick={() => {
					downloadFile(row)
				}}
				title={text}
			>
			</Button >
		),
	]
	return (
		<Space direction="vertical" size={20} style={{ width: "100%", position: 'relative', }}>

			{isLoader && <PreloaderNew />}
			
			<Table
				columns={columns}
				size="small"
				rowKey={obj => obj.id}
				pagination={false}
				style={{ overflowX: "auto" }}
				className="table"
				dataSource={docData?.results}
			/>

		</Space>
	)
}

function createColumn(title, key, render) {
	return { title, key, dataIndex: key, render }
}
export default Documentation;
